import { render, staticRenderFns } from "./KeyGuestReminder.vue?vue&type=template&id=347dc00f&"
import script from "./KeyGuestReminder.vue?vue&type=script&lang=ts&"
export * from "./KeyGuestReminder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports